import Vue from 'vue';
import App from './App.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading, {
	color: '#0856ab'
});
import router from './router';
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
import { store } from './stores';
Vue.config.productionTip = false
import { i18n } from './plugins/i18n';
import PluginCore from './shared/core';
Vue.use(PluginCore);
new Vue({
	store,
	i18n,
	router,
	render: h => h(App),
	created(){
		let lcstorage = localStorage.getItem('jwt');
		if(lcstorage != null){
			this.$api().post('initialize').then(res => {
				if(this.$isValid(res)){
					let lang = res.data.Json.Lang;
					if(lang == undefined || lang == null || lang == '') lang = 'en';
					this.$store.state.lang = lang;
					this.$i18n.locale = lang;
					this.$store.commit('updateUserGroup', res.data.Json.UserGroup);
				}
			});
		}
	}
}).$mount('#app');
